import { Typography } from "@mui/material";
import Container from "@mui/material/Container";
import highfid from "../../images/film/highfid.jpg";
import ledzep from "../../images/film/ledzep.jpg";
import yellowsub from "../../images/film/yellowsub.jpg";
import angine from "../../images/film/angine.jpg";

function Film() {
  return (
    <Container className="info" maxWidth="xl">
      <div className="info-content">
        <div className="text-section">
          <Typography className="title" variant="h6">
            FILM SCREENINGS
          </Typography>
          <Typography className="title venue-title" variant="h6">
            UPSTAIRS @ LASS O'GOWRIE
          </Typography>
        </div>
        <div className="text-section">
          <div className="film-row">
            <div>
              <Typography className="title film-title" variant="h6">
                HIGH FIDELITY <span>13:00</span>
              </Typography>
            </div>

            <img
              src={highfid}
              className="high-fid-film"
              alt="acompleteunknown film"
            />
          </div>
        </div>
        <div className="text-section">
          <div className="film-row">
            <div>
              <Typography className="title film-title" variant="h6">
                BECOMING LED ZEPLIN <span>15:30</span>
              </Typography>
            </div>
            <img src={ledzep} className="led-zep-film" alt="bird film" />
          </div>
        </div>
        <div className="text-section">
          <div className="film-row">
            <div>
              <Typography className="title film-title" variant="h6">
                YELLOW SUBMARINE <span>18:00</span>
              </Typography>
            </div>
            <img src={yellowsub} className="yellow-sub-film" alt="oasis film" />
          </div>
        </div>
        <div className="text-section">
          <div className="film-row">
            <div>
              <Typography className="title film-title" variant="h6">
                ANGINE DE POITRINE LIVE ON KEXP <span>20:15</span>
              </Typography>
            </div>
            <img src={angine} className="angine-film" alt="oasis film" />
          </div>
        </div>
        <div className="text-section">
          <Typography className="title" variant="h6">
            Contact
          </Typography>
          <Typography className="text">info@manchesterpsychfest.com</Typography>
        </div>
      </div>
    </Container>
  );
}
export default Film;
